import { Injectable } from '@angular/core';
import {
  LoadEventSponsorshipState,
  LoadEventSponsorshipStateSuccess,
  LoadEventSponsorshipStateFail,
  EventSponsorshipActionTypes,
} from './event-sponsorship.actions';
import { IEventSponsorship, LGEDataService } from 'src/commons';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { from, of, catchError, map, switchMap } from 'rxjs';

@Injectable()
export class EventSponsorshipEffects {
  loadPlantPlanetState$ = createEffect(() =>
    this.actions$.pipe(
      ofType(EventSponsorshipActionTypes.LoadEventSponsorshipState),
      map((action: LoadEventSponsorshipState) => action.formId),
      switchMap((formId) =>
        from(this.lgeService.formESById(formId)).pipe(
          map(
            (state: IEventSponsorship) =>
              new LoadEventSponsorshipStateSuccess(state)
          ),
          catchError((error) => of(new LoadEventSponsorshipStateFail(error)))
        )
      )
    )
  );

  constructor(private actions$: Actions, private lgeService: LGEDataService) {}
}
